import React, {
    useMemo,
    useRef
} from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';

import {Button} from 'primereact/button';
import {Panel} from 'primereact/panel';

import ContentButton, {
    ReferenceType as ContentButtonType
} from '~/frontend/src/components/base/shared/ContentButton';

import messageCatalog, {__} from '~/shared/src/utilities/messageCatalog';
import {getIconCssClassName} from '~/shared/src/utilities/getCssClassName';

import {
    AppDispatch,
    StoreState
} from '~/frontend/src/store';
import setLanguage from '~/frontend/src/actions/user/setLanguage';


type DefaultProps = {
    temporary? : boolean;
};
const defaultProps : Required<DefaultProps> = {
    temporary: false
};

type Props = {

    /**
     * The CSS class name(s) to add to the component.
     */
    className? : string;
};

type AllProps = Required<DefaultProps> & Props;


/**
 * language menu
 * @return {JSX.Element}
 * @constructor
 */
const LanguageButton = ( props : AllProps ) => {
    const {
              className,
              temporary
          }                      = props,
          dispatch : AppDispatch = useDispatch(),
          user                   = useSelector( ( state : StoreState ) => state.session?.user ? state.session.user : undefined ),
          languageButton         = useRef<ContentButtonType>( null ),
          languageKeyPrefix      = 'FSZ:base:supportedLanguages:',
          language               = useMemo(
              () => {
                  return user?.language ?? '';
              },
              [
                  user
              ]
          ),
          supportedLanguages     = useMemo(
              () => Object.keys( global.config.common.supportedLanguages ) as string[],
              [
                  global.config.common.supportedLanguages
              ]
          ),
          languageButtons        = useMemo(
              () => {
                  const retVal : React.ReactNode[] = [];

                  if ( language ) {
                      for ( const supportedLanguage of supportedLanguages ) {
                          messageCatalog.language = supportedLanguage;

                          retVal.push(
                              <Button
                                  key={supportedLanguage}
                                  label={__( `${languageKeyPrefix}${supportedLanguage}` )}
                                  icon={`yn-menu-icon yn-icon yn-language-icon ${getIconCssClassName( 'byRef', `${languageKeyPrefix}${supportedLanguage}` )}`}
                                  disabled={supportedLanguage === language}
                                  className="yn-menu-button yn-no-rounded-borders"
                                  style={{ width: '100%' }}
                                  rounded={false}
                                  text={true}
                                  outlined={false}
                                  onClick={( event ) => {
                                      languageButton.current?.collapse( event );
                                      void dispatch( setLanguage( supportedLanguage, temporary ) );
                                  }}
                              />
                          );
                      }

                      messageCatalog.language = language;
                  }

                  return retVal;
              },
              [
                  language,
                  supportedLanguages
              ]
          );

    return useMemo(
        () => {
            if ( user ) {
                return <ContentButton
                    id="page-menu-language-button"
                    ref={languageButton}

                    horizontalContentAlign="left"
                    verticalContentAlign="bottom"
                    rounded={true}
                    text={true}
                    icon={`yn-button-icon ${getIconCssClassName( 'byRef', `${languageKeyPrefix}${language}` )}`}
                    className={`yn-language-button ${className}`}
                    buttonClassName="yn-language-button"
                    contentClassName="yn-contentbutton-overlay-content-page-menu"

                    content={
                        <Panel
                            style={{ width: '12rem' }}
                            pt={{
                                content: {
                                    style: {
                                        border : 'none',
                                        padding: '.5rem 1rem'
                                    }
                                }
                            }}
                        >
                            {languageButtons}
                        </Panel>
                    }
                />;
            }
            else {
                return <></>;
            }
        },
        [
            className,
            language,
            languageButtons,
            user
        ]
    );
};
LanguageButton.defaultProps = defaultProps;
LanguageButton.displayName = 'LanguageButton';

export default LanguageButton;
